import React, { useState, useEffect } from 'react';

// Libs
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNodeId } from '@xyflow/react';

// Funções
import { useNodeUpdate } from '~/hooks/useNodeUpdate';

// Utilitários
import { NodeHeaderCustomDeleteAction } from '~/utils/NodeHeaderCustomDeleteAction';
import { NodeHeaderCustomAlertAction } from '~/utils/NodeHeaderCustomAlertAction';
import { CustomInputDrop } from '~/utils/CustomInputDrop';
import { CustomHandle } from '~/utils/CustomHandle';

// Node de decisão
// Este componente permite que o usuário defina uma expressão lógica para decidir o fluxo do programa
// Ele possui dois caminhos de saída: verdadeiro e falso, dependendo do resultado da expressão
// O usuário pode arrastar e soltar variáveis ou expressões para definir a lógica da decisão
// O nó também verifica pendências, como se a expressão está preenchida corretamente
// e exibe alertas se necessário
export const DecidirNode = ({ data }) => {
    const id = useNodeId();
    const { onNodesChange } = useNodeUpdate();
    const [dropData, setDropData] = useState(data.dropData || { id: 'custom', type: null, data: {} });
    const [listaPendencias, setListaPendencias] = useState([]);

    // sync on undo/redo
    useEffect(() => { setDropData(data.dropData || { id: 'custom', type: null, data: {} }); }, [data.dropData]);

    const handleDropChange = (newDrop) => {
        setDropData(newDrop);
        onNodesChange([{ id, type: 'update', data: { dropData: newDrop } }]);
    };

    const conferePendencias = () => {
        const pendencias = [];
        if (!dropData.type && !dropData.data.value) pendencias.push('Expressão não preenchida');
        setListaPendencias(pendencias);
        return pendencias;
    };

    useEffect(() => { conferePendencias(); }, [dropData]);

    return (
        <div className="node node-mostrar">
            <div className="titulo-node">
                <FontAwesomeIcon icon="fa-solid fa-question" />
                {data.label.toUpperCase()}
            </div>
            <div className="linha-separadora" />
            <CustomHandle type="target" position="top" connectionCount={1} allowLoopConnections={true} />
            <div className="node-geral">
                <div className="node-botoes">
                    <button title="Executar este comando" onClick={() => alert('Executar')}><FontAwesomeIcon icon="fa-solid fa-circle-play" /></button>
                    <NodeHeaderCustomDeleteAction />
                    {listaPendencias.length > 0 && <NodeHeaderCustomAlertAction conferePendencias={conferePendencias} nodeData={data} />}
                </div>
                <div className="node-principal" style={{ position: 'relative' }}>
                    <CustomInputDrop dropData={dropData} dropId="custom" onDropChange={handleDropChange} />
                </div>
            </div>
            {/* Handle Falso com legenda */}
            <div style={{
                position: 'absolute',
                left: '-40px',
                top: '50%',
                transform: 'translateY(-50%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '4px'
            }}>
                <CustomHandle
                    type="source"
                    position="left"
                    id="falso"
                    connectionCount={1}
                    style={{
                        backgroundColor: '#ff4444',
                        border: '2px solid #cc0000',
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        position: 'relative',
                        left: '20px',
                        top: '0'
                    }}
                />
                <span style={{
                    fontSize: '10px',
                    fontWeight: 'bold',
                    color: '#ff4444',
                    background: 'white',
                    padding: '2px 4px',
                    borderRadius: '4px',
                    border: '1px solid #ff4444',
                    whiteSpace: 'nowrap',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                    marginLeft: '20px'
                }}>
                    FALSO
                </span>
            </div>

            {/* Handle Verdadeiro com legenda */}
            <div style={{
                position: 'absolute',
                right: '-55px',
                top: '50%',
                transform: 'translateY(-50%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '4px'
            }}>
                <CustomHandle
                    type="source"
                    position="right"
                    id="verdadeiro"
                    connectionCount={1}
                    style={{
                        backgroundColor: '#44ff44',
                        border: '2px solid #00cc00',
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        position: 'relative',
                        left: '-20px',
                        top: '0'
                    }}
                />
                <span style={{
                    fontSize: '10px',
                    fontWeight: 'bold',
                    color: '#00cc00',
                    background: 'white',
                    padding: '2px 4px',
                    borderRadius: '4px',
                    border: '1px solid #00cc00',
                    whiteSpace: 'nowrap',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                    marginRight: '20px'
                }}>
                    VERDADEIRO
                </span>
            </div>
        </div>
    );
};